class Rebut {
    constructor(
        public id = 0,
        public key = 0,
        public id_contacte = 0,
        public quota = null,
        public remesa = "",
        public preu = null,
        public estat = "",
        public pagament = "",
        public alta = "",
        public modificacio = "",
        public concepte = "",
        public iban = "",
        public pagador = "",
        public afegit = "",
        public id_activitat = null,
        public id_centre = null,
        public observacions = "",
        public pagat = null
    ) {
        this.id = id;
        this.key = key;
        this.id_contacte = id_contacte;
        this.quota = quota;
        this.remesa = remesa;
        this.preu = preu;
        this.estat = estat;
        this.pagament = pagament;
        this.alta = alta;
        this.modificacio = modificacio;
        this.concepte = concepte;
        this.iban = iban;
        this.pagador = pagador;
        this.afegit = afegit;
        this.id_activitat = id_activitat;
        this.id_centre = id_centre;
        this.observacions = observacions;
        this.pagat = pagat;
    }
}

export default Rebut;
